import React, { useState, useEffect } from 'react'
import { ListItemButton, ListItemIcon, ListItemText, Collapse, List, Checkbox } from '@mui/material'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import DataObjectIcon from '@mui/icons-material/DataObject'
import HighlightAltIcon from '@mui/icons-material/HighlightAlt'
import {
  setNewExpandedKeys,
  cleanKey,
  removeIndexIfIsArrayIndex,
  addIndentIfIsArrayIndex,
} from 'src/helper/MapperHelper'
import { maxCharactersToString } from 'src/helper/maxCharactersToString'

export function CustomListItem(props) {
  const { propKey, propValue, setCheckedBox, checkedNodes, setCheckedNodes, indent, selected, setSelected } =
    props

  const [checked, setChecked] = useState([])
  const handleClick = (key) => {
    setNewExpandedKeys(checkedNodes, setCheckedNodes, removeIndexIfIsArrayIndex(key, indent))
    setSelected(key)
  }

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]
    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }
    setCheckedBox(newChecked)
    setChecked(newChecked)
    setSelected(value)
  }

  return (
    <>
      <ListItemButton onClick={() => handleClick(propKey)} selected={selected === propKey}>
        <ListItemIcon>
          <DataObjectIcon />
        </ListItemIcon>
        <ListItemText primary={cleanKey(propKey)} />
        {checkedNodes[indent] === addIndentIfIsArrayIndex(propKey, indent) ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      {React.Children.toArray(
        Object.entries(propValue).map((element) => {
          const [key, value] = element
          let key_clean = cleanKey(key)
          // const labelId = `checkbox-list-label-${value}`
          return (
            <Collapse
              in={checkedNodes[indent] === addIndentIfIsArrayIndex(propKey, indent) ? true : false}
              timeout='auto'
              unmountOnExit
            >
              <List component='div' disablePadding sx={{ pl: 10 }}>
                {typeof value !== 'object' || value == null ? (
                  <ListItemButton onClick={handleToggle(key)} selected={selected === key}>
                    <ListItemIcon>
                      {/* <Checkbox
                                edge='start'
                                checked={checkedBox.indexOf(key) !== -1}
                                tabIndex={-1}
                                disableRipple
                                inputProps={{ 'aria-labelledby': labelId }}
                              /> */}
                      <HighlightAltIcon />
                    </ListItemIcon>
                    <ListItemText primary={`${key_clean} : ${maxCharactersToString(value)}`} />
                  </ListItemButton>
                ) : (
                  <CustomListItem
                    propKey={key}
                    propValue={value}
                    setCheckedBox={setCheckedBox}
                    checkedNodes={checkedNodes}
                    setCheckedNodes={setCheckedNodes}
                    indent={indent + 1}
                    selected={selected}
                    setSelected={setSelected}
                  />
                )}
              </List>
            </Collapse>
          )
        })
      )}
    </>
  )
}
